<template>
<div class="cfd-thead"
    :style="`transform: translateY(${wrapperScrollTop}px)`">
    <div class="cfd-tr">
        <template v-for="column in columnsToShow">
            <template v-if="!column.SubColumns || !column.SubColumns.length">
                <InstrumentTableHeaderItem :column="column" :key="column.MatchingFieldName"/>
            </template>
            <template v-else>
                <InstrumentTableHeaderItem v-for="subcolumn in column.SubColumns"
                    :column="subcolumn"
                    :key="subcolumn.MatchingFieldName"/>
            </template>
        </template>
    </div>
</div>
</template>

<script>
import InstrumentTableHeaderItem from './InstrumentTableHeaderItem.vue';

export default {
    name: 'InstrumentTableHeader',

    components: {
        InstrumentTableHeaderItem
    },

    data () {
        return {
            headerOffset: null,
            wrapperRef: null,
            wrapperScrollTop: 0
        }
    },

    computed: {
        columnsToShow () {
            return this.$store.state.columnsToShow;
        }
    },

    methods: {
        handleScroll (ev) {
            const wrapperRect = this.wrapperRef.getBoundingClientRect();
            if (wrapperRect.top < this.headerOffset) {
                if (wrapperRect.top < 0) {
                    this.wrapperScrollTop = Math.abs(wrapperRect.top) + this.headerOffset;
                } else {
                    this.wrapperScrollTop = this.headerOffset - wrapperRect.top;
                }
            } else {
                this.wrapperScrollTop = 0;
            }
        },

        bindHandlers () {
            window.addEventListener('scroll', this.handleScroll);
        },

        unbindHandlers () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },

    mounted () {
        this.wrapperRef = document.querySelector('.cfd-wrapper')
        const headerOffsetToInt = parseInt(this.$store.state.headerOffset);
        if (isNaN(headerOffsetToInt)) {
            // looks like it's a CSS selector
            const element = document.querySelector(this.$store.state.headerOffset);
            if (!element) {
                this.headerOffset = 0;
            } else {
                this.headerOffset = element.offsetHeight;
            }
        } else {
            // looks like it's a number
            this.headerOffset = headerOffsetToInt;
        }
        this.bindHandlers()
    },

    beforeDestroy () {
        this.unbindHandlers()
    }
};
</script>

<style scoped>
.cfd-thead {
    display: table-header-group;
    background-color: #fff;
    will-change: transform;
}

.cfd-tr {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/components/desktop/InstrumentTableHeader.vue